import {
  GET_CATEGARY,
  GET_SKILLS,
  GET_DEGREE,
  GET_PROFICIENCY,
  GET_LANGUAGE,
  GET_SUBCATEGARY,
  GET_DELIVERY_TYPE,
  GET_INDUSTRY,
  GET_PENALTY,
  GET_PRIORITY,
  GET_RATING,
  GET_SKILLS_WITH_CATEGORY
} from "../constants";

export const categary = (
  state = {
    categarylist: [],
    skilllist: {},
    degreelist: {},
    proficiencylist: {},
    languagelist: {},
    subcategarylist: {},
    deliverytypelist: {},
    industrylist: {},
    penaltylist: {},
    prioritylist: {},
    ratinglist: {},
    skilllistwithcategory: {},
  },
  action
) => {
  switch (action.type) {
    case GET_CATEGARY:
      return { ...state, categarylist: action.categarylist };
    case GET_SKILLS:
      return { ...state, skilllist: action.skilllist };
    case GET_DEGREE:
      return { ...state, degreelist: action.degreelist };
    case GET_INDUSTRY:
      return { ...state, industrylist: action.industrylist };
    case GET_PROFICIENCY:
      return { ...state, proficiencylist: action.proficiencylist };
    case GET_LANGUAGE:
      return { ...state, languagelist: action.languagelist };
    case GET_SUBCATEGARY:
      return { ...state, subcategarylist: action.subcategarylist };
    case GET_DELIVERY_TYPE:
      return { ...state, deliverytypelist: action.deliverytypelist };
    case GET_PENALTY:
      return { ...state, penaltylist: action.penaltylist };
    case GET_PRIORITY:
      return { ...state, prioritylist: action.prioritylist };
    case GET_RATING:
      return { ...state, ratinglist: action.ratinglist };
    case GET_SKILLS_WITH_CATEGORY:
      return { ...state, skilllistwithcategory: action.skilllistwithcategory };
    default:
      return state;
  }
};
